export const columns = [
  { id: "venNumFactura", label: "Documento", align: "center", ordenable: true },
  { id: "venRucCliente", label: "Ruc. Cliente", align: "center", ordenable: true },
  { id: "venNomCliente", label: "Cliente", align: "left", ordenable: true },
  { id: "venFormaPago", label: "F. Pago", align: "center", ordenable: true },
  { id: "venFechaFactura", label: "Fecha", align: "center", ordenable: true },
  { id: "venFacturaCredito", label: "Crédito", align: "center", ordenable: true },
  { id: "venTotal", label: "Total", align: "center", ordenable: true },
  { id: "venEstado", label: "Estado", align: "center", ordenable: true },
  { id: "venAutorizacion", label: "Autorización", align: "center", ordenable: false },
  { id: "venEnvio", label: "Envio", align: "center", ordenable: true },
  { id: "venObservacion", label: "Observación", align: "left", ordenable: false },
  { id: "venFecReg", label: "Fec. Reg.", align: "center", ordenable: true },
  { id: "venUser", label: "Usuario", align: "center", ordenable: false },
];

export const TABLA = "venta";
export const CAMPO_EXPORT = "venId";

export const ESTADOS = [
  { label: "FACTURAS", estado: "FACTURAS" },
  { label: "CALIBRACIÓN", estado: "NOTA VENTAS" },
  { label: "PROFORMAS", estado: "PROFORMAS" },
  { label: "NOTA CREDITOS", estado: "NOTA CREDITOS" },
  { label: "SIN AUTORIZAR", estado: "SIN AUTORIZAR" },
  { label: "ANULADAS", estado: "ANULADAS" },
];

export const ESTADOS_NEIMAR = [
  { label: "DESPACHO", estado: "DESPACHO" },
  { label: "ALIMENTACION", estado: "ALIMENTACION" },
  { label: "COMBUSTIBLE", estado: "COMBUSTIBLE" },
];

export const objectDefault = {
  venEmpRegimen: "",
  venProductosAntiguos: [],
  optionDocumento: "",
  venTotalRetencion: "0.00",
  venOption: "1",
  venTipoDocumento: "F",
  venIdCliente: "1",
  idAbastecimiento: 0,
  totInicio: 0,
  totFinal: 0,
  manguera: 0,
  venRucCliente: "9999999999999",
  venTipoDocuCliente: "RUC",
  venNomCliente: "CONSUMIDOR FINAL",
  venFlota: "",
  venEmailCliente: ["sin@sincorreo.com"],
  venTelfCliente: "0000000001",
  venCeluCliente: "0000000001",
  venDirCliente: "s/n",
  venEmpRuc: "",
  venEmpNombre: "",
  venEmpComercial: "",
  venEmpDireccion: "",
  venEmpTelefono: "",
  venEmpEmail: "",
  venEmpObligado: "",
  venFormaPago: "TRANSFERENCIA",
  venNumero: "0",
  venFacturaCredito: "NO",
  venDias: "0",
  venAbono: "0",
  venDescPorcentaje: "0",
  venOtrosDetalles: "",
  venObservacion: "",
  venSubTotal12: "",
  venSubtotal0: "",
  venDescuento: "",
  venSubTotal: "",
  venTotalIva: "",
  venTotal: "0.00",
  venCostoProduccion: "",
  venUser: "",
  venFechaFactura: `${new Date().getFullYear()}-${(
    "0" +
    (new Date().getMonth() + 1)
  ).slice(-2)}-${("0" + new Date().getDate()).slice(-2)}`,
  venNumFactura: "",
  venNumFacturaAnterior: "",
  venAutorizacion: "0",
  venFechaAutorizacion: "",
  venErrorAutorizacion: "NO",
  venEstado: "ACTIVA",
  venEnvio: "NO",
  fechaSustentoFactura: "",
  venEmpresa: "",
  venProductos: [],
};

export const filtrosDefault = {
  venNumFactura: "",
  venRucCliente: "",
  venNomCliente: "",
  venFormaPago: "",
  venFechaFactura1: null,
  venFechaFactura2: null,
  venFacturaCredito: "",
  venTotal1: "",
  venTotal2: "",
  venEstado: "",
  venAutorizacion: "",
  venEnvio: "",
  venObservacion: "",
  venFecReg1: null,
  venFecReg2: null,
  venUser: "",
  venFlota: "",
  horarios: "",
};

export const inventarioDefault = {
  invSerie: "0",
  invTipo: "",
  invNombre: "",
  invDescripcion: "",
  invCosto1: "",
  invCosto2: "",
  invCosto3: "",
  invStock: "",
  invIva: "SI",
  invIncluyeIva: "SI",
  invEstado: "ACTIVA",
  invBodegas: [],
  invprecios: [],
  invProveedor: "",
  invCategoria: "",
  invSubCategoria: "",
  invUnidad: "",
  invMarca: "",
  invSubsidio: "0",
  invPlanCuenta: "",
  invEmpresa: "",
  invUser: "admin",
  invFecReg: "",
  Todos: "",
};

export const proveedorDefault = {
  perISPContratos: [],
  perNombreComercial: "",
  perEmpresa: [],
  perPais: "",
  perProvincia: "",
  perCanton: "",
  perTipoProveedor: "BIENES",
  perTiempoCredito: "0",
  perDocTipo: "",
  perDocNumero: "",
  perPerfil: [],
  perNombre: "",
  perDireccion: "",
  perObligado: "NO",
  perCredito: "NO",
  perTelefono: "0",
  perCelular: ["+593"],
  perEstado: "ACTIVO",
  perObsevacion: "",
  perEmail: ["sin@sincorreo.com"],
  perOtros: ["ZZZ9999"],
  perNickname: "",
  perUser: "",
  perFecReg: "",
  perFoto: "",
  perUbicacion: {
    longitud: "",
    latitud: "",
  },
  perDocumento: "",
  perGenero: "M",
  perRecomendacion: "OTROS",
  perFecNacimiento: "",
  perEspecialidad: "",
  perTitulo: "",
  perSenescyt: "",
  perPersonal: "INTERNO",
  validateEmail: 1,
};
